import dynamic from 'next/dynamic';
import { useState } from 'react';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
const CardH = dynamic(import('src/components/cards/card-h'));

const CardSubMenu = ({ small = false, data, eventDataLayer, heading }) => {
  if (_.isEmpty(data)) return null
  const [articles, setArticles] = useState({
    key: null,
    data: data[0]?.data,
    link: data[0]?.link,
    name: data[0]?.nameTh
  });

  return (
    <>
      <div className={`card-wrapper ${small && '--small'}`}>
        <div className={`row card-sub-menu ${small && '--small'}`}>
          <div className='col-4'>
            <ul>
              {data.map((item, index) => (
                <a
                  key={index}
                  href={item?.link}
                  //! DATALAYER
                  onClick={() =>
                    sendDataLayerGlobal({
                      ...eventDataLayer,
                      data: {
                        title: item?.nameTh,
                        heading: `${heading}:${item?.nameTh}`
                      }
                    })
                  }
                >
                  <li
                    aria-hidden='true'
                    onMouseOver={() => {
                      setArticles({
                        key: index,
                        data: item?.data,
                        link: item?.link,
                        name: item?.nameTh
                      });
                    }}
                    onFocus={() => { }}
                  >
                    {item?.nameTh}
                  </li>
                </a>
              ))}
            </ul>
          </div>
          <div className='col-8 card-sub-menu-content'>
            {articles?.data?.map((item, index) => {
              return (
                <CardH
                key={index}
                data={item}
                withMB='mb-2'
                shortDate={true}
                txtStyle={true}
                eyeBall={false}
                eventDataLayer={{
                  ...eventDataLayer,
                  data: {
                    heading: `${heading ?? ''}:${item?.subCategory?.th || ''}`,
                    title: item?.title || 'Default Title' // Provide a default value if `title` is potentially null/undefined
                  }
                }}
              />
              )
            })}
            <div className='btn-readmore'>
              <a href={articles?.link}>ดูทั้งหมด</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CardSubMenu;
